module.exports = __webpack_public_path__ + "static/NotoSansThai-Bold.subset-da4c0415e3d4747927fe054e1b89e93a.otf";